import { gql } from 'apollo-boost';

export const INITIATE_MULTIPART_UPLOAD = gql`
    mutation($data: InitiateMultipartUploadInput!) {
        initiateMultipartUpload(data: $data) {
            uploadId
            key
            parts {
                partNumber
                signedUrl
            }
        }
    }
`;

export const COMPLETE_MULTIPART_UPLOAD = gql`
    mutation($data: CompleteMultipartUploadInput!) {
        completeMultipartUpload(data: $data) {
            url
            key
        }
    }
`;

export const ABORT_MULTIPART_UPLOAD = gql`
    mutation($data: AbortMultipartUploadInput!) {
        abortMultipartUpload(data: $data)
    }
`;
